import { defineStore } from 'pinia'

import { StorageHelper } from '@/helpers/storage-helper'
import { RepositoryFactory } from '@/repositories/repositoryFactory'

interface AppError {
  message: string
}

interface BlogsPageData {
  data: any
  loading: boolean
  error: AppError | null
  initialized: boolean
  singlePageData: any
  blogData: any
}

const blogsPageRepository: any = RepositoryFactory.get('blogsRepository')

export const useBlogsPageStore = defineStore('blogs', {
  state: () =>
    <BlogsPageData>{
      data: StorageHelper.getItemUncrypted('blogsData', []),
      loading: true,
      error: null,
      initialized: false,
      singlePageData: StorageHelper.getItemUncrypted('singlePageData', []),
      blogData: StorageHelper.getItemUncrypted('blogData', [])
    },
  getters: {
    getBlogsPageData: (state) => state.data,
    getBlogsPageLoading: (state) => state.loading,
    getSinglePageData: (state) => state.singlePageData,
    getBlogData: (state) => state.blogData
  },
  actions: {
    async fetchBlogsBySlug(slug: string) {
      this.loading = true
      try {
        const response = await blogsPageRepository.getBlogBySlug({}, slug)
        this.data = response.data
        StorageHelper.setItemUncrypted('singlePageData', this.data)
        this.initialized = true
      } catch (error) {
        this.initialized = true
        console.error('Error fetching:', error)
        this.error = {
          message: 'Problem with fetching blogs'
        }
        throw error
      } finally {
        this.initialized = true
        this.loading = false
      }
    },
    async fetchLatestBlogs(category: string) {
      this.loading = true
      try {
        const response = await blogsPageRepository.getLatestBlogs({}, category)
        const items = response.data?.filter((item: any) => !item?.fields?.hidden) ?? []
        this.blogData = items.slice(0, 5)
        StorageHelper.setItemUncrypted('blogData', this.blogData)
        this.initialized = true
      } catch (error) {
        this.initialized = true
        console.error('Error fetching:', error)
        this.error = {
          message: 'Problem with fetching single page blogs data'
        }
        throw error
      } finally {
        this.initialized = true
        this.loading = false
      }
    }
  }
})
